import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Button, MenuItem, Stack, TextField } from "@mui/material";
import { useUpdateElementMutation } from "@/api/templatesApi";
import { Drawer, WebsiteElement } from "@/types";

interface Props {
  selectedElement: Drawer | null;
}

type DrawerElement = WebsiteElement & {
  title: string;
  position?: string;
  width?: string;
};

const DrawerSettings = ({ selectedElement }: Props) => {
  const { templateId } = useParams<{ templateId: string }>();
  const [updateElement] = useUpdateElementMutation();

  if (!selectedElement || selectedElement.type !== "drawer") {
    return null;
  }

  const drawerElement = selectedElement as DrawerElement;

  return (
    <Formik
      enableReinitialize
      initialValues={
        {
          title: drawerElement?.title ?? "",
          position: drawerElement?.position ?? "right",
          width: drawerElement?.width ?? "50%",
        } as Partial<Drawer>
      }
      onSubmit={async (values: Partial<Drawer>) => {
        await updateElement({
          templateId,
          payload: {
            ...drawerElement,
            title: values.title ?? drawerElement?.title ?? "",
            position: values.position ?? drawerElement?.position ?? "right",
            width: values.width ?? drawerElement?.width ?? "50%",
          },
        });
      }}
    >
      {({ values, handleChange }) => (
        <Form>
          <Stack spacing={2}>
            <TextField size="small" name="title" label="Título" value={values.title ?? ""} onChange={handleChange} />
            <Stack direction="row" spacing={2} flex={1}>
              <TextField fullWidth size="small" select name="position" label="Posición" value={values.position ?? "right"} onChange={handleChange}>
                <MenuItem value="left">Izquierda</MenuItem>
                <MenuItem value="right">Derecha</MenuItem>
                <MenuItem value="top">Arriba</MenuItem>
                <MenuItem value="bottom">Abajo</MenuItem>
              </TextField>
              <TextField fullWidth size="small" select name="width" label="Ancho" value={values.width ?? "40%"} onChange={handleChange}>
                <MenuItem value="40%">Pequeño</MenuItem>
                <MenuItem value="50%">Mediano</MenuItem>
                <MenuItem value="80%">Grande</MenuItem>
                <MenuItem value="100%">Pantalla completa</MenuItem>
              </TextField>
            </Stack>
            <Button variant="contained" color="primary" type="submit">
              Guardar
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default DrawerSettings;
